'use client'

import { useEffect, useState } from 'react'

import type { Parkinglot } from '@/components/detail/components/shared/parkinglotInfo/model'
import type { ParkinglotWithDistance } from '@/components/recommendParkinglot/viewModel'

import type { ParkinglotPhoto } from '@/api/server/detail/dto/detailDto'
import FullScreenImageViewer from '@/shared/components/fullScreen/FullScreenImageViewer'
import type { Photo } from '@/shared/components/fullScreen/FullScreenImageViewer'
import SliderCore from '@/shared/components/slider/components/SliderCore'
import type { SliderOptions } from '@/shared/components/slider/types/sliderOptions'

export type SlideItem = Photo | ParkinglotWithDistance | Parkinglot | ParkinglotPhoto

interface SliderViewProps {
  options: SliderOptions
  items: SlideItem[]
  slideComponent: ({
    item,
    imgIndex,
    setCurrentSlide
  }: {
    item: SlideItem
    imgIndex: number
    setCurrentSlide: React.Dispatch<React.SetStateAction<number>>
  }) => JSX.Element
  id?: string
}

const SliderView = ({ options, items, slideComponent, id }: SliderViewProps) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isViewerOpen, setIsViewerOpen] = useState(false)
  const [isAnimationStart, setIsAnimationStart] = useState(false)

  const handleSliderClick = () => {
    if (!options.fullScreen) return
    setIsViewerOpen(true)
    setTimeout(() => {
      setIsAnimationStart(true)
    }, 0)
  }

  const handleViewerClose = () => {
    if (!options.fullScreen) return
    setIsAnimationStart(false)
    setTimeout(() => {
      setIsViewerOpen(false)
    }, 500)
  }

  useEffect(() => {
    setCurrentSlide(0)
  }, [items])
  return (
    <>
      <SliderCore
        currentSlide={currentSlide}
        setCurrentSlide={setCurrentSlide}
        options={options}
        onClick={handleSliderClick}
        slideComponent={slideComponent}
        items={items}
      />
      {options.fullScreen && (
        <FullScreenImageViewer
          currentSlide={currentSlide}
          setCurrentSlide={setCurrentSlide}
          items={items}
          onClose={handleViewerClose}
          isOpen={isViewerOpen}
          isAnimationStart={isAnimationStart}
          id={id}
        />
      )}
    </>
  )
}

export default SliderView
